export default __webpack_public_path__ + "media/images/backgrounds/bg-05-1920x718-eac04163fab3ec324554cb0ea7bbbf7a.jpg";